import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const CtaBand = ({ title = "Ready when you are.", copy = "Tell us about your business and what you need. We'll send back a straight answer and a fair price — no pressure, no jargon." }) => (
  <section className="grain bg-[#233D35] text-[#F3EFE5]" data-testid="cta-band">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20 relative z-[2]">
      <Reveal>
        <Eyebrow light>Get a Free Quote</Eyebrow>
        <h2 className="font-head font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-3 max-w-3xl leading-[0.95]">
          {title}
        </h2>
        <p className="mt-5 max-w-xl text-[#F3EFE5]/75 text-base sm:text-lg leading-relaxed">{copy}</p>
        <div className="mt-8">
          <Link
            to="/contact"
            data-testid="cta-band-quote-btn"
            className="group inline-flex items-center gap-2 bg-[#C58A47] hover:bg-[#B0793A] text-[#F3EFE5] font-head font-bold uppercase tracking-[0.12em] px-7 py-4 text-base transition-colors duration-200"
          >
            Get a Free Quote
            <ArrowRight size={18} className="transition-transform duration-200 group-hover:translate-x-1" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CtaBand;
